import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

// A theme with custom primary and secondary color.
const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#bdbdbd',
      main: '#ff9500',
      dark: '#8d8d8d',
      contrastText: '#ffffff'
    },
    secondary: {
      light: '#ffffff',
      main: '#ffffff',
      dark: '#ffffff',
      contrastText: '#ff9500'
    },
    mediaDisplay: {
      light: '#000',
      main: '#000',
      dark: '#000',
      contrastText: '#ff9500'
    }
  },
});

function withTheme(Component) {
  function withTheme(props) {
    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
    return (
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  }

  return withTheme;
}

export default withTheme;



// WEBPACK FOOTER //
// ./src/withTheme.js